import { MenuItem, MenuItemProps } from '@mui/material'
import { ReactNode } from 'react'

type Props = {
  children: ReactNode
  className?: string
} & MenuItemProps

export const StyledMenuItem = ({
  children,
  className = '',
  ...rest
}: Props) => {
  return (
    <MenuItem
      className={className}
      sx={(theme) => ({
        // width: '111px',
        height: '56px',
        justifyContent: 'start',
        alignItems: 'center',
        paddingLeft: '15px',
        // paddingRight: '27px',
        py: '15px',
        gap: '8px',
        fontSize: '16px',
        lineHeight: '26px',
        fontWeight: 500,
        color: theme.palette.custom.zBlack200,
        // backgroundColor: `${theme.palette.custom.zGrey200}`,
        // borderRadius: '20px',
        '&.Mui-selected': {
          backgroundColor: 'transparent',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'transparent',
        },
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&.Mui-focusVisible': {
          backgroundColor: 'transparent',
        },
        '&.Mui-selected.Mui-focusVisible': {
          backgroundColor: 'transparent',
        },
        '&.MuiMenuItem-root.Mui-selected': {
          backgroundColor: 'transparent !important',
        },
      })}
      {...rest}>
      {children}
    </MenuItem>
  )
}
